import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import HeaderSearch from './HeaderSearch';
import HoverLinkBtn from '../button/HoverLinkBtn';
import HeaderCartBtn from '../button/HeaderCartBtn';
import HeaderMyBtn from '../button/HeaderMyBtn';
import { setBrandSelDataResetAction } from '../../../modules/common/brandModule';
import { useDispatch } from "react-redux";
import { resetCateInfoAction } from '../../../modules/common/cateModule';
import { setSearchTextAction } from '../../../modules/search/searchModule';
import { Link, useHistory } from 'react-router-dom';
import { useState, useEffect ,useRef } from 'react';
/**
 * Header의 GNB
 */
const HeaderGnbBlock = styled.div`
    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;
const HeaderGnbUlBlock = styled.ul`
    display: inline-block;
    /* position: absolute;
    top: 32px;
    left : 168px;
     left: 50%;
    margin-left: -50px;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);   
    float: left;
    padding-left: 52px; */
    margin-top: 11px;
    font-size: 18px;
    font-weight: 700;
      
    ::after {
        content: "";
        display: block;
        clear: both;
    }
    `;

const HeaderGnbLiBlock = styled.li`
    position: relative;
    float: left;
    //padding-left: 50px;
    padding-left: 29px;
    font-size: 18px;
    font-weight: 700;
    line-height:1.2;
`;

const HeaderSearchInfolock = styled.div`
    float: right;
    padding-right: 6px;
    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const HeaderGnb = () => {
    const dispatch = useDispatch();
    const [curText, setCurText] = useState("");
    const history = useHistory();
    const inputRef = useRef(null);

    // Redux Store에서 저장된 값을 가져옴
    var { curMenu, searchText } = useSelector(
        ({ headerReducer, searchReducer }) => ({
            curMenu: headerReducer.curMenu,
            searchText: searchReducer.searchText,
        })
    );

    const menuTitle = [
        // { title: '가구견적', link: '/es', menu: 'es' },
        // { title: '공간투어', link: '/st', menu: 'st' },
        { title: '카테고리', link: '/ct', menu: 'ct' },
        { title: '브랜드관', link: '/br', menu: 'br' },
        { title: '이벤트', link: '/em', menu: 'em' }
    ];

    useEffect(() => {
        if(inputRef&&inputRef.current && (curMenu === 'search' || curMenu === 'searchBrand')) {
            inputRef.current.value = searchText;
        } else if(inputRef&&inputRef.current) {
            inputRef.current.value = '';
        }
    }, [searchText, curMenu]);

    const handleMenuClick = () => {
        dispatch(setBrandSelDataResetAction()); //브랜드관 초기화
        dispatch(resetCateInfoAction()); // 카테고리 초기화
    }

    const handleSearch = () => {
        // console.log("handleSearch = " + curMenu)
        // console.log("curText = " + curText)

        /* if (curMenu === 'search') {
            dispatch(setSearchTextAction(curText));
        }
        else {
            if (curText !== null && curText !== undefined && curText.length > 0) {
                // console.log("curText = " + curText);

                let tempText = curText.replace(/ /g, "");
                // console.log("tempText = " + tempText);
                if (tempText.length > 0) {
                    history.push("/search");
                    dispatch(setSearchTextAction(curText));
                }
            }
        } */

        if (curText !== null && curText !== undefined && curText.length > 0) {
            // console.log("curText = " + curText);

            let tempText = curText.replace(/ /g, "");
            // console.log("tempText = " + tempText);
            if (tempText.length > 0) {
                if (curMenu === 'search') {
                    history.replace("/search?q="+ curText);
                } else if (curMenu ==='searchBrand') {
                    history.replace("/searchBrand?q="+curText);
                } else {
                    history.push("/search?q="+curText);
                }
            }
        }
    }

    const handleChangeInput = (e) => {
        setCurText(e.target.value);
    }

    return (
        <HeaderGnbBlock>
            <HeaderGnbUlBlock>
                <HeaderGnbLiBlock>
                    <HoverLinkBtn text="끄-적"
                                  bottom="0"
                                  height="1px"
                                  link="/estimate/step1"
                                  isUnderLine={curMenu === "esapply"}
                                  onClick={handleMenuClick}>
                    </HoverLinkBtn>
                </HeaderGnbLiBlock>
                <HeaderGnbLiBlock>
                    <HoverLinkBtn text="견적"
                                  bottom="0"
                                  height="1px"
                                  link="/es"
                                  icon={curMenu === "es"?"/assets/images/icon/kkjcheck_selected.png":"/assets/images/icon/kkjcheck_normal.png"}
                                  iconWidth="32px"
                                  iconHeight="16px"
                                  isUnderLine={curMenu === "es"}
                                  onClick={handleMenuClick}>
                    </HoverLinkBtn>
                </HeaderGnbLiBlock>
                {
                    menuTitle.map((curitem, idx) => {
                        return (
                            <HeaderGnbLiBlock key={idx}>
                                <HoverLinkBtn text={curitem.title}
                                    bottom="0"
                                    height="1px"
                                    link={curitem.link}
                                    isDot={'es' === curitem.menu}
                                    isUnderLine={curMenu === curitem.menu}
                                    onClick={handleMenuClick}>
                                </HoverLinkBtn>
                            </HeaderGnbLiBlock>
                        );
                    })
                }
                <HeaderGnbLiBlock>
                    <HoverLinkBtn text="스토어"
                              bottom="0"
                              height="1px"
                              link="https://shop.odgagu.co.kr"
                              external={true}
                              icon="/assets/images/icon/store_sublogo.svg"
                              iconValign="top"
                              iconWidth="47px"
                              iconHeight="20px"
                              onClick={handleMenuClick}>
                    </HoverLinkBtn>
                </HeaderGnbLiBlock>
            </HeaderGnbUlBlock>
            <HeaderSearchInfolock>
                <HeaderSearch onClick={handleSearch} onChange={handleChangeInput} enterPress={handleSearch} inputRef = {inputRef} />
                <HeaderSearchInfolock>
                    <HeaderCartBtn />
                    <HeaderMyBtn />
                </HeaderSearchInfolock>
            </HeaderSearchInfolock>

        </HeaderGnbBlock>
    );
};

export default HeaderGnb;
